window.onload = function() {
  const spinner = document.getElementById('loading');
  spinner.classList.add('loaded');
}
// setTimeout(loaderClose,1000);